import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import './index.less';
import { stringToDom } from '@/utils/dom';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';
/**
 * 展示同活动订单弹窗
 * @param orderInfo - 订单信息
 * @param config - 弹窗配置
 */

export function showSameActivityOrderModal(orderInfo, config) {
  var title = config.title,
      btnText = config.btnText,
      onOk = config.onOk,
      trackType = config.trackType; // 曝光埋点

  sensElementView({
    c_element_name: "\u540C\u6D3B\u52A8\u6821\u9A8C\u5F39\u7A97",
    material_type: trackType,
    activity_label: '投放'
  }); // 渲染弹窗 HTML

  var modalHtml = "\n    <div class=\"same-activity-order-modal\" id=\"j-same-activity-order-modal\">\n      <div class=\"saom-mask\"></div>\n      <div class=\"saom-content\">\n        <!-- \u9876\u90E8\u88C5\u9970\u56FE\u6807 -->\n        <div class=\"saom-icon\">\n          <i class=\"ui-icon ui-icon-img_09\"></i>\n        </div>\n        \n        <!-- \u5E95\u90E8\u5361\u7247 -->\n        <div class=\"saom-card\">\n          <!-- \u4FE1\u606F\u533A\u57DF -->\n          <div class=\"saom-info\">\n            <!-- \u6807\u9898 -->\n            <div class=\"saom-title\">".concat(title, "</div>\n            \n            <!-- \u8BA2\u5355\u4FE1\u606F -->\n            <div class=\"saom-order-info\">\n              <div class=\"saom-order-header\">\u6211\u7684\u5185\u5BB9</div>\n              <div class=\"saom-order-card\">\n                <div class=\"saom-order-product\">\n                  <img class=\"saom-order-img\" src=\"").concat(orderInfo.courseImg || '', "\" alt=\"\u5546\u54C1\" />\n                  <div class=\"saom-order-name\">").concat(orderInfo.courseName || '', "</div>\n                </div>\n                <div class=\"saom-order-detail\">\n                  ").concat(orderInfo.orderTime ? "\n                    <div class=\"saom-order-row\">\n                      <span class=\"saom-order-label\">\u4E0B\u5355\u65F6\u95F4</span>\n                      <span class=\"saom-order-value\">".concat(orderInfo.orderTime, "</span>\n                    </div>\n                  ") : '', "\n                </div>\n              </div>\n            </div>\n          </div>\n          \n          <!-- \u64CD\u4F5C\u533A\u57DF -->\n          <div class=\"saom-action\">\n            <button class=\"saom-btn\" id=\"j-saom-btn\">").concat(btnText, "</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  ");
  var $modal = document.getElementById('j-same-activity-order-modal');

  if ($modal) {
    $modal.remove();
  }

  document.body.appendChild(stringToDom(modalHtml)); // 绑定事件

  var $btn = document.getElementById('j-saom-btn');
  var $mask = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.saom-mask'); // 按钮点击

  $btn === null || $btn === void 0 ? void 0 : $btn.addEventListener('click', function () {
    // 点击埋点
    var isConfirmPage = window.location.pathname.indexOf('/confirm.html') >= 0;
    sensClickInitiative({
      $element_name: "".concat(btnText),
      activity_label: '投放',
      $element_type: '弹窗按钮',
      material_position: isConfirmPage ? '确认订单页' : '确认订单弹窗'
    });
    $modal === null || $modal === void 0 ? void 0 : $modal.remove();
    onOk();
  }); // 点击蒙层关闭

  $mask === null || $mask === void 0 ? void 0 : $mask.addEventListener('click', function () {
    $modal === null || $modal === void 0 ? void 0 : $modal.remove();
  });
}